import revive_payload_client_4sVQNw7RlN from "/home/jetmix/production/storebusters-landing/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import components_plugin_KR1HBZs4kY from "/home/jetmix/production/storebusters-landing/.nuxt/components.plugin.mjs";
import unhead_KgADcZ0jPj from "/home/jetmix/production/storebusters-landing/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/jetmix/production/storebusters-landing/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import prefetch_client_5tzzN0oIVL from "/home/jetmix/production/storebusters-landing/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_bKSoGl1L7p from "/home/jetmix/production/storebusters-landing/node_modules/yandex-metrika-module-nuxt3/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/home/jetmix/production/storebusters-landing/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import axios_QMFgzss1s4 from "/home/jetmix/production/storebusters-landing/plugins/axios.ts";
import Vue3Lottie_client_bMZiOS6AB0 from "/home/jetmix/production/storebusters-landing/plugins/Vue3Lottie.client.ts";
import sentry_3AyO8nEfhE from "/home/jetmix/production/storebusters-landing/plugins/sentry.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  components_plugin_KR1HBZs4kY,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  prefetch_client_5tzzN0oIVL,
  plugin_bKSoGl1L7p,
  chunk_reload_client_UciE0i6zes,
  axios_QMFgzss1s4,
  Vue3Lottie_client_bMZiOS6AB0,
  sentry_3AyO8nEfhE
]